export default __webpack_public_path__ + "static/media/tesda-1.2330f2df.jpg";